var React = require('react');

function Dimension (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M50,19.49L14.77,80.51H85.23L50,19.49z M49.342,59.263L17.352,78.439l31.991-55.41V59.263z M49.946,60.3l32.528,19.01    H18.233L49.946,60.3z M50.542,59.258V22.83l31.742,54.98L50.542,59.258z"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M29.959,60.677c-0.099,0-0.199-0.025-0.292-0.076c-0.289-0.162-0.393-0.527-0.232-0.816l8.48-15.194    c0.162-0.289,0.526-0.393,0.816-0.232c0.289,0.162,0.393,0.527,0.232,0.816l-8.48,15.194    C30.374,60.566,30.17,60.677,29.959,60.677z"}))]));
}

Dimension.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Dimension;

Dimension.default = Dimension;
